import React from 'react';
import { BwjViewManager, BwjViewState } from '../framework/components/bwj-view-manager';
import { useStandardResourceNotFoundState } from '../entities/view-manager/not-found';

export const ResourceNotFoundPage: React.FunctionComponent = () => {
  const notFoundState = useStandardResourceNotFoundState();

  return (
    <BwjViewManager
      state={BwjViewState.PageNotFound}
      pageNotFoundState={notFoundState}
    />
  );
};
